module.exports = __webpack_public_path__ + "img/hr-garballo-03.40d190a5.png";